import api from './api';

const draftContractService = {
  // Get all draft contracts
  getAllDraftContracts: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.contractType) queryParams.append('contractType', params.contractType);
      if (params.partyId) queryParams.append('partyId', params.partyId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.priority) queryParams.append('priority', params.priority);
      if (params.legalReviewStatus) queryParams.append('legalReviewStatus', params.legalReviewStatus);

      const queryString = queryParams.toString();
      const url = `/draft-contract${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching draft contracts:', error);
      throw error;
    }
  },

  // Get draft contract by ID
  getDraftContractById: async (id) => {
    try {
      const response = await api.get(`/draft-contract/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching draft contract:', error);
      throw error;
    }
  },

  // Get next contract number
  getNextContractNumber: async () => {
    try {
      const response = await api.get('/draft-contract/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next contract number:', error);
      throw error;
    }
  },

  // Create draft contract
  createDraftContract: async (contractData) => {
    try {
      const response = await api.post('/draft-contract', contractData);
      return response.data;
    } catch (error) {
      console.error('Error creating draft contract:', error);
      throw error;
    }
  },

  // Update draft contract
  updateDraftContract: async (id, contractData) => {
    try {
      const response = await api.put(`/draft-contract/${id}`, contractData);
      return response.data;
    } catch (error) {
      console.error('Error updating draft contract:', error);
      throw error;
    }
  },

  // Delete draft contract
  deleteDraftContract: async (id) => {
    try {
      const response = await api.delete(`/draft-contract/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting draft contract:', error);
      throw error;
    }
  },

  // Get draft contract statistics
  getDraftContractStats: async () => {
    try {
      const response = await api.get('/draft-contract/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching draft contract statistics:', error);
      throw error;
    }
  },

  // Submit contract for review
  submitForReview: async (id, notes) => {
    try {
      const response = await api.put(`/draft-contract/${id}/submit`, { notes });
      return response.data;
    } catch (error) {
      console.error('Error submitting contract for review:', error);
      throw error;
    }
  }
};

export default draftContractService;

